function Contact({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 19 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 22.59V18.99C3.99 18.73 0 14.57 0 9.5C0 4.26 4.26 0 9.5 0C14.74 0 19 4.26 19 9.5C19 14.45 15.56 19.43 10.43 21.9L9 22.59ZM9.5 2C5.36 2 2 5.36 2 9.5C2 13.64 5.36 17 9.5 17H11V19.3C14.64 17 17 13.22 17 9.5C17 5.36 13.64 2 9.5 2ZM8.5 13.5H10.5V15.5H8.5V13.5ZM10.5 12H8.5C8.5 8.75 11.5 9 11.5 7C11.5 5.9 10.6 5 9.5 5C8.4 5 7.5 5.9 7.5 7H5.5C5.5 4.79 7.29 3 9.5 3C11.71 3 13.5 4.79 13.5 7C13.5 9.5 10.5 9.75 10.5 12Z" fill=${`"${col}"`}/>
    </svg>
  `;

  return baseXml;
}

export default Contact;
